import emit from '../../common/events';
import store from '../../store/store';
import { ariaLabelWithNewTab } from '../../common/utils/a11y-util';
import { BaseComponent } from '../base-component/base-component';
import { CANCELATION_FREE_TRIAL_HELP_URL, getOrderHistoryPageURL } from './utils/free-trial.util';
import { StoreState } from '../../store/store.interface';
import { TemplateResult, html } from 'lit';
import { booleanConverter } from '../../common/converters';
import { customElement, property } from 'lit/decorators.js';

@customElement('mhecomm-signedin-availability-free-trial')
export class SignedinAvailabilityFreeTrial extends BaseComponent {
  /**
   * The free trial duration in days.
   */
  @property({ type: Number })
  freeTrialDuration = 0;

  /**
   * Indicates if the component is being used in the cart list.
   */
  @property({ converter: booleanConverter })
  isCartList = false;

  /**
   * The ISBN of the product.
   */
  @property()
  isbn?: string;

  renderComp(): TemplateResult {
    return html`
      <div class="alert alert-success mb-0">
        ${this.isCartList ? this.getCartListMessage() : this.getOtherPagesMessage()}
      </div>
    `;
  }

  /**
   * Gets the message for the free trial availability on cart item list.
   */
  private getCartListMessage(): TemplateResult {
    return html`
      <div class="fw-bold">
         Proceed to checkout to view eligibility for ${this.freeTrialDuration}-Day free trial access.
      </div>
      <mhecomm-free-trial-remove-from-cart isbn="${this.isbn}"></mhecomm-free-trial-remove-from-cart>
    `;
  }

  /**
   * Gets the message for the free trial availability on other pages.
   */
  private getOtherPagesMessage(): TemplateResult {
    return html`
      <div class="col-12 fw-bold">
        ${this.uxtIconReady ? html` <uxt-icon icon="check-circle" class="me-2"></uxt-icon>` : ''}${this
          .freeTrialDuration}-Day
        free trial access
      </div>
      <div class="col-12">
        <p class="fs-small mb-0">
          Free cancellation any time before the end of the trial period. Trials automatically continue as paid
          subscriptions, unless canceled before end of the respective trial period. Cancel before your free trial ends
          in
          <a
            href=${getOrderHistoryPageURL(store.getState() as StoreState)}
            @click=${() => this.fireAnalytics('My Account Order History')}
            >My Account &gt; Order History</a
          >
          to avoid getting billed.
          <a
            href=${CANCELATION_FREE_TRIAL_HELP_URL}
            aria-label="${ariaLabelWithNewTab('How do I cancel a free trial?')}"
            target="_blank"
            @click=${() => this.fireAnalytics('How do I cancel a free trial')}
            >How do I cancel a free trial?</a
          >
        </p>
      </div>
    `;
  }

  private fireAnalytics(eventName) {
    emit({
      element: this,
      name: 'click',
      detail: {
        label: eventName,
        eventName: eventName.toLowerCase().replace(/\s/g, '-'),
        verbiage: 'signedin-availability-free-trial',
      },
    });
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'mhecomm-signedin-availability-free-trial': SignedinAvailabilityFreeTrial;
  }
}
